import React from 'react';
import PricingOption from './PricingOption.js';

const PluginHeader = ({ price, monthlySubscriptionAvailable, note, downloadUrlLite, downloadUrlPro, showHelpLink = true, showTitle = true, className }) => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      {showTitle &&
        (
          <h3 className="text-4xl font-semibold text-center">
            <span className="relative mr-3 px-2">
              <span className="absolute -inset-1 block -skew-y-3 bg-sky-600" aria-hidden="true"></span>
              <span className="relative text-white">Pricing</span>
            </span>
          </h3>
        )}

      {/* pricing option based on the input */}
      <PricingOption
        price={price}
        note={note}
        monthlySubscriptionAvailable={monthlySubscriptionAvailable}
        showHelpLink={showHelpLink}
      />

      {/* Call to Action Buttons */}
      {(downloadUrlLite || downloadUrlPro) && (
        <div className="mt-12 flex flex-col sm:flex-row justify-center gap-6">

          {downloadUrlLite &&
            <a
              href={downloadUrlLite}
              className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-full text-white bg-green-500 hover:bg-green-400 transition duration-300 shadow-lg focus:ring-4 focus:ring-green-300 focus:outline-none hover:no-underline"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6 mr-3"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                />
              </svg>
              Download for Aronium Lite
            </a>
          }

          {downloadUrlPro &&
            <a
              href={downloadUrlPro}
              className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-full text-white bg-blue-500 hover:bg-blue-400 transition duration-300 shadow-lg focus:ring-4 focus:ring-blue-300 focus:outline-none hover:no-underline"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6 mr-3"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                />
              </svg>
              Download for Aronium Pro
            </a>
          }
        </div>
      )}
    </div>
  )
}

export default PluginHeader;